export const NOTIFICATION_MESSAGES = {
  contacts: {
    copySuccess: "전화번호가 복사되었습니다.",
    copyFailed: "전화번호를 복사하지 못했습니다.",
    phoneNumberMissing: "복사할 전화번호가 없습니다.",
  },
};
